module.exports = __webpack_public_path__ + "static/025.thumb-ef3e6057f0d7662142e2c0182f7c1e75.jpg";